import React from "react";
import {
  Route,
  Switch,
  browserHistory,
  NavLink,
  Link,
  withRouter,
} from "react-router-dom";
import { makeRequestAuth, uploadRequest } from "../../utils/globals";
import ProfileService from "../../services/profileService";
import { getUserBalance } from "../../global/getUserBalance";

var downloadTimer;

class PaypalPaymentStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: this.props.match.params.id,
      // order_id:this.props.match.params.key,
      order_status_id: "",
      error: false,
      timer: "",
      redirect: true,
      redirectPath: "",
      loadPollingApi: false,
    };
  }

  componentDidMount() {
    const { updateUserBalance } = this.props;
    const response = this.props.history.location.state
      ? JSON.parse(this.props.history.location.state)
      : "";
    // if(response && response.origin == 'plumPro'){
    // 	this.plumProPoints();
    // 	this.getUserBalance()
    // }else{
    // 	this.getUserBalance()
    // }
    const company_recharge = response && response.company_recharge;

    this.setState({
      redirectPath: response && response.callbackPath,
      order_id: response && response.order_id,
      origin: response && response.origin,
      status: response && response.status,
      order_status_id: response && response.order_status_id,
      amount: response && response.amount,
      company_recharge,
      rechargeFailReason:
        response && response.rechargeFailReason
          ? response.srechargeFailReason
          : null,
    });
    if (response && response.origin == "plumPro") {
      this.plumProPoints();
    } else {
      getUserBalance(updateUserBalance);
    }
    this.successRedirect(company_recharge);
  }

  plumProPoints = () => {
    const { updatePlumProPoints } = this.props;

    ProfileService.plumProPoints({})
      .then((response) => {
        if (
          response &&
          response.cashReserveBalance &&
          response.cashReserveBalance.status == true
        ) {
          let data = response.cashReserveBalance.data.balance;

          updatePlumProPoints(data);
        }
      })
      .catch((error) => {});
  };

  getBalanceToShow = (company_recharge) => {
    const {
      accountReducer: {
        userBalance: { userBalance = 0, companyBalance = 0 } = {},
        plumProPoints: { balance = 0 } = {},
        typeData: { walletCompany = 0 } = {},
      } = {},
    } = this.props;
    let balanceToShow = 0;
    if (this.state.origin === "plumPro") {
      if (walletCompany) {
        balanceToShow = userBalance;
      } else {
        balanceToShow = balance;
      }
    } else {
      if (company_recharge === 1) {
        balanceToShow = companyBalance;
      } else {
        balanceToShow = userBalance;
      }
    }

    return balanceToShow;
  };

  successRedirect = (company_recharge) => {
    if (
      this.state.order_status_id !== undefined &&
      this.state.error === false &&
      this.state.status == "success"
    ) {
      //this.getUserBalance()
      var timeleft = 5;
      downloadTimer = setInterval(
        function () {
          timeleft--;
          this.setState({ timer: timeleft });

          if (timeleft <= 0 && this.state.redirect) {
            clearInterval(downloadTimer);
            this.props.history.push({
              pathname: "/admin/recharge/",
              state: JSON.stringify({
                paymentStatus: this.state.status,
                amount: this.state.amount,
                userBalance: this.getBalanceToShow(company_recharge),
              }),
            });
          }
        }.bind(this),
        1000
      );
    }
  };
  redirectToAdmin = (type) => {
    const { company_recharge } = this.state;
    clearInterval(downloadTimer);
    this.props.history.push({
      pathname: "/admin/recharge/",
      state: JSON.stringify({
        paymentStatus: this.state.status,
        amount: this.state.amount,
        userBalance: this.getBalanceToShow(company_recharge),
        rechargeFailReason:
          this.state.status == "fail" ? this.state.rechargeFailReason : null,
      }),
    });

    this.setState({ redirect: false });
  };

  render() {
    const { classes, theme } = this.props;
    const redirectPath = this.props.history.location.state
      ? JSON.parse(this.props.history.location.state)
      : "";

    return (
      <div
        className="container padding-top-20 CreateXoxoVoucher afterPaymentMsg"
        style={{ paddingBottom: "20px" }}
      >
        <div className="messageContainer">
          {this.state.order_status_id !== undefined &&
          this.state.order_status_id !== 5 &&
          this.state.order_status_id &&
          this.state.error === false &&
          this.state.status == "success" ? (
            <div className="msgBlock successMsg">
              <div className="statusicon">
                <object
                  type="image/svg+xml"
                  width="100%"
                  data="/admin/img/svg-icons/Correct.svg"
                />
              </div>
              <div className="msgText">
                <h2 style={{ color: "green" }}>Payment Successful!</h2>
                <strong>Your Order id is: {this.state.order_id}</strong>
                <p style={{ fontStyle: "normal" }}>
                  You will receive an email from xoxoday of your payment
                  details.
                </p>

                <br />

                {this.state.timer ? (
                  <p>
                    You are being redirected in {this.state.timer} seconds...{" "}
                  </p>
                ) : null}
                <br />
                <a
                  onClick={() => {
                    this.redirectToAdmin(
                      redirectPath && redirectPath.callbackPath
                        ? redirectPath.callbackPath
                        : ""
                    );
                  }}
                >
                  Go to Admin Page
                </a>
                {/* <a onClick={()=>{this.redirectToAdmin("giftcard")}}>Go to Admin Page</a> */}
              </div>
            </div>
          ) : null}
          {this.state.status == "cancel" ? (
            <div className="msgBlock errorMsg">
              <div className="statusicon">
                <object
                  type="image/svg+xml"
                  width="100%"
                  data="/admin/img/svg-icons/Error.svg"
                />
              </div>
              <div className="msgText">
                <h2 style={{ color: "red" }}>Payment has been canceled</h2>
                <p style={{ color: "red" }}>
                  Your payment could not be processed successfully. In case any
                  funds got deducted from your bank for this transaction, please
                  drop an e-mail to cs@giift.com. Our team will reach out to
                  you for assistance.
                </p>
                <p style={{ fontStyle: "normal" }}>
                  Your order id is: {this.state.order_id}
                </p>
                <a
                  onClick={() => {
                    this.redirectToAdmin(
                      redirectPath && redirectPath.callbackPath
                        ? redirectPath.callbackPath
                        : ""
                    );
                  }}
                >
                  Go to Admin Page
                </a>
              </div>
            </div>
          ) : null}
          {this.state.status == "fail" ? (
            <div className="msgBlock errorMsg">
              <div className="statusicon">
                <object
                  type="image/svg+xml"
                  width="100%"
                  data="/admin/img/svg-icons/Error.svg"
                />
              </div>
              <div className="msgText">
                <h2 style={{ color: "red" }}>Payment Failed</h2>
                <p style={{ color: "red" }}>
                  {" "}
                  Your payment could not be processed successfully. Please try
                  again after some time or drop an e-mail to cs@giift.com for
                  support{" "}
                </p>
                <p style={{ fontStyle: "normal" }}>
                  Your order id is: {this.state.order_id}
                </p>
                <a
                  onClick={() => {
                    this.redirectToAdmin(
                      redirectPath && redirectPath.callbackPath
                        ? redirectPath.callbackPath
                        : ""
                    );
                  }}
                >
                  Go to Admin Page
                </a>
              </div>
            </div>
          ) : null}
          {this.state.status == "pending" ? (
            <div className="msgBlock errorMsg">
              <div className="statusicon">
                <object
                  type="image/svg+xml"
                  width="100%"
                  data="/admin/img/svg-icons/Error.svg"
                />
              </div>
              <div className="msgText">
                <h2 style={{ color: "red" }}>Payment Pending</h2>
                <p style={{ color: "red" }}>
                  Your payment could not be processed successfully. In case any
                  funds got deducted from your bank for this transaction, please
                  drop an e-mail to cs@giift.com. Our team will reach out to
                  you for assistance.
                </p>
                <p style={{ fontStyle: "normal" }}>
                  Your order id is: {this.state.order_id}
                </p>
                <a
                  onClick={() => {
                    this.redirectToAdmin(
                      redirectPath && redirectPath.callbackPath
                        ? redirectPath.callbackPath
                        : ""
                    );
                  }}
                >
                  Go to Admin Page
                </a>
              </div>
            </div>
          ) : null}
          {this.state.error === true ? (
            <div className="msgBlock errorMsg">
              <div className="statusicon">
                <object
                  type="image/svg+xml"
                  width="100%"
                  data="/admin/img/svg-icons/Error.svg"
                />
              </div>
              <div className="msgText">
                <h2 style={{ color: "red" }}>Payment Failed</h2>
                <p style={{ color: "red" }}>
                  {" "}
                  Your payment could not be processed successfully. Please try
                  again after some time or drop an e-mail to cs@giift.com for
                  support{" "}
                </p>
                <p style={{ fontStyle: "normal" }}>
                  Your order id is: {this.state.order_id}
                </p>
                <a
                  onClick={() => {
                    this.redirectToAdmin(
                      redirectPath && redirectPath.callbackPath
                        ? redirectPath.callbackPath
                        : ""
                    );
                  }}
                >
                  Go to Admin Page
                </a>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
export default withRouter(PaypalPaymentStatus);
